"use strict";

/**
 * @classdesc
 * Einfaches Featureobjekt einer Transaktions-Funktion des FeatureServices.
 *
 * @class
 * @extends gc.gis.service.feature.AbstractTransactionFeature
 * @memberof gc.gis.service
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.service.feature.TransactionSimpleFeature = function()
{
	gc.gis.service.feature.AbstractTransactionFeature.call(this);

	/**
	 * Geometrie
	 * @var gc.gis.geom.GCGeometry
	 */
	this._geometry = undefined;
};
gc.gis.service.feature.TransactionSimpleFeature.prototype = Object.create(gc.gis.service.feature.AbstractTransactionFeature.prototype);

/**
 * Liefert die Geometrie.
 *
 * @return {gc.gis.geom.GCGeometry}
 */
gc.gis.service.feature.TransactionSimpleFeature.prototype.getGeometry = function ()
{
	return this._geometry;
};

/**
 * Setzt die Geometrie.
 *
 * @param {gc.gis.geom.GCGeometry} geometry
 * @return {gc.gis.service.feature.TransactionSimpleFeature}
 */
gc.gis.service.feature.TransactionSimpleFeature.prototype.setGeometry = function (geometry)
{
	this._geometry = geometry;
	return this;
};